<div class="grafana-container">
    <iframe #grafanaIframe
    [src]="url | sensorstationsUrl"
      width="100%"
      height="575"
      frameborder="0">
    </iframe>
  </div>